import React, { useEffect, useState } from "react";
import { getPartsInventoryList } from "../../services/PartsInventory";
import { useTranslation } from "react-i18next";
import ReactPaginate from "react-paginate";
import ConfigDB from "../../config";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import Utils from "../../utils";
import { Button } from "reactstrap";

const PartInventoryFilterList = ({
  setPartIdData,
  partIdData,
  setStep,
  reserveDetails,
  setPartNewData,
  partNewData,
}) => {
  const [partsInventoryList, setPartsInventoryList] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [loading, setLoading] = useState(false);
  const [addedLers, setAddedLers] = useState([]);
  const [addedLerss, setAddedLerss] = useState([]);

  const { t } = useTranslation();

  const location = useLocation();

  const tableLengthList = ConfigDB.data.dataTableLength;
  const data = localStorage.getItem(ConfigDB.data.login_data);
  const companyId = JSON.parse(data);

  const [params, setParams] = useState({
    limit: tableLengthList[0],
    page: 1,
    search: "",
    is_reload: false,
    company_id: companyId.company_id || 0,
    vehicle_year: "",
    vehicle_model: "",
    vehicle_variant: "",
    vehicle_make: "",
    catalog_name: "",
    part_name: "",
    inventory_status: 0,
    record_show_type: 0,
    internal_id: "",
    search_warehouse: "",
    search_warehouse_barcode: "",
    vehicle_type: "",
    vehicle_fuel: "",
    vehicle_doors: "",
    part_type: "",
    part_location: "",
    part_group: "",
    part_side: "",
    brand_id: "",
    condition_id: "",
    state_id: "",
    type_damage_id: "",
    location_damage_id: "",
    order_type: "",
    reference_name: "",
    price_from: "",
    price_to: "",
    rating_from: "",
    rating_to: "",
    part_with_price: "0",
    part_with_photo: "0",
    part_with_reference: "0",
    part_with_damage: "0",
    is_compatible_search: "",
    is_sales: true,
  });

  useEffect(() => {
    if (partNewData) {
      setAddedLers(partNewData);
    }
  }, []);

  useEffect(() => {
    if (reserveDetails?.part_list?.length && partsInventoryList?.length) {
      const preSelected = reserveDetails?.part_list?.map((part) => {
        const matchedPart = partsInventoryList.find(
          (item) => Number(item.id) === Number(part.parts_id),
        );

        return {
          id: Number(part.parts_id),
          parts_id: part.parts_id,
          parts_internal_id: matchedPart?.parts_internal_id || "",
          namePartPT: matchedPart?.namePartPT || "",
          vehicle_model_name: matchedPart?.vehicle_model_name || "",
          vehicle_make_name: matchedPart?.vehicle_make_name || "",
          quantity: matchedPart?.quantity || 0,
        };
      });

      setAddedLerss(preSelected);
    }
  }, [reserveDetails, partsInventoryList]);

  const filteredPartAssignLerList = (partsInventoryList || []).filter(
    (item) => !addedLers.some((ler) => ler.id === item.id), // not newly added
    // !addedLerss.some((ler) => ler.id === item.id)  // not already in reserve
    // item.inventory_status === 1 &&
    // item.quantity >= 1,
  );

  useEffect(() => {
    const currentPath = location.pathname;
    const savedPath = localStorage.getItem("lastVisitedPath");

    if (savedPath && savedPath !== currentPath) {
      localStorage.removeItem("lastVisitedPage");
      localStorage.removeItem("filterData");
    }

    localStorage.setItem("lastVisitedPath", currentPath);

    const savedPage = localStorage.getItem("lastVisitedPage");
    if (savedPage) {
      setParams((prevParams) => ({
        ...prevParams,
        page: parseInt(savedPage, 10),
      }));
    }
  }, [location.pathname, params?.page]);

  const handleParams = (e, type) => {
    let paramsObj = { ...params };
    if (type === "length") {
      paramsObj.limit = e.target.value;
    } else if (type === "search") {
      paramsObj.page = 1;
      paramsObj.search = e.target.value;
    } else if (type === "pagination") {
      paramsObj.page = e.selected + 1;
      localStorage.setItem("lastVisitedPage", e.selected + 1);
    }

    setParams(paramsObj);
  };

  useEffect(() => {
    let data = { ...params };

    getPartsInventoryList(data)
      .then((response) => {
        setPartsInventoryList(response.data.data);
        setTotalRecords(response.data.total);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      })
      .finally(() => {
        setLoading(false);
      });
  }, [params]);

  const handleAddClickLER = async (
    id,
    parts_internal_id,
    namePartPT,
    vehicle_model_name,
    vehicle_make_name,
    quantity,
  ) => {
    const isAdded = addedLers?.some((ler) => ler.id === id);

    if (isAdded) {
      try {
      } catch (error) {
        console.error(`Error deleting item with ID ${id}:`, error);
      }

      setAddedLers((prev = []) => prev.filter((ler) => ler?.id !== id));
    } else {
      setAddedLers((prev = []) => [
        ...prev,
        {
          id,
          parts_internal_id,
          namePartPT,
          vehicle_model_name,
          vehicle_make_name,
          quantity,
        },
      ]);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (addedLers.length === 0 && addedLerss.length === 0) {
      toast.error(t("at_least_one_part_required"));
      return;
    }

    const combinedParts = [...addedLerss, ...addedLers]; // existing + new
    setPartIdData(combinedParts); // Send full list

    setPartNewData(addedLers);
    setStep(3);
  };

  return (
    <div>
      <section className="content">
        <div className="container-fluidcontainer-custom-height-new">
          <div className="row">
            <div className="col-md-12">
              <div className="card fuelCard">
                <div className="">
                  <div className="">
                    <div className="card-header">
                      <div className="card-title m-0 float-left d-flex">
                        <button
                          type="button"
                          className="btn btn-block btn-primary"
                          onClick={() => setStep(1)}
                          style={{ width: "100px", marginTop: "10px" }}
                        >{t("back")}<i className="bi bi-arrow-left-short"></i>
                        </button>
                      </div>
                      <div className="card-title m-0 float-right d-flex">
                        <button
                          type="button"
                          className="btn btn-block btn-primary"
                          onClick={handleSubmit}
                          style={{ width: "100px", marginTop: "10px" }}
                        >{t("next")}<i className="bi bi-x-lg"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6">
              <input
                type="text"
                className="form-control"
                value={params.search}
                onChange={(e) => handleParams(e, "search")}
                placeholder={t("search")}
                style={{ marginBottom: "10px" }}
              ></input>
              <div className="vehicleThBg table-responsive">
                <table className="rounded-table table table-striped table-bordered table-hover">
                  <thead>
                    <tr>
                      <th style={{ width: "10%" }}>{t("Internal_Id")}</th>
                      <th style={{ width: "10%" }}>{t("part_name")}</th>
                      <th style={{ width: "10%" }}>{t("Model")}</th>
                      <th style={{ width: "10%" }}>{t("make")}</th>
                      <th style={{ width: "10%" }}>{t("quantity")}</th>
                      <th style={{ width: "10%" }}>{t("action")}</th>
                    </tr>
                  </thead>

                  <tbody>
                    {filteredPartAssignLerList.length > 0 ? (
                      filteredPartAssignLerList.map((item, index) => {
                        const isAdded = addedLerss.some(
                          (ler) => ler.id === item.id,
                        );

                        return (
                          <tr key={index}>
                            <td>{item.parts_internal_id}</td>
                            <td>{item.namePartPT}</td>
                            <td>{item.vehicle_model_name}</td>
                            <td>{item.vehicle_make_name}</td>
                            <td>{item?.quantity}</td>

                            <td>
                              {isAdded ? (
                                <>
                                  <i
                                    className="bi bi-check-lg"
                                    style={{
                                      fontSize: "16px",
                                      fontWeight: "400",
                                      color: "green",
                                    }}
                                  >
                                    Added
                                  </i>
                                </>
                              ) : (
                                <Button
                                  className="addBtn"
                                  onClick={() =>
                                    handleAddClickLER(
                                      item.id,
                                      item.parts_internal_id,
                                      item.namePartPT,
                                      item.vehicle_model_name,
                                      item.vehicle_make_name,
                                      item?.quantity,
                                    )
                                  }
                                  disabled={isAdded}
                                  style={{
                                    cursor: isAdded ? "not-allowed" : "pointer",
                                  }}
                                >
                                  <i className="bi bi-plus-lg"></i>
                                </Button>
                              )}
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr className="scrollBrdr">
                        <td colSpan="100%">{t("no_record_found")}</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
              <div className="card-footer clearfix card-footer-part">
                <div className="pagination pagination-sm m-0  paginationRight">
                  <ReactPaginate
                    previousLabel={
                      <i className="bi bi-chevron-double-left"></i>
                    }
                    nextLabel={<i className="bi bi-chevron-double-right"></i>}
                    breakLabel={"..."}
                    pageCount={Math.ceil(totalRecords / params.limit)}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={5}
                    onPageChange={(e) => handleParams(e, "pagination")}
                    forcePage={params.page - 1}
                    containerClassName={"pagination"}
                    activeClassName={"active"}
                    pageClassName={"page-item"}
                    pageLinkClassName={"page-link"}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div
                className="vehicleThBg table-responsive"
                style={{ marginTop: "48px" }}
              >
                <table className="rounded-table table table-striped table-bordered table-hover">
                  <thead>
                    <tr>
                      <th style={{ width: "10%" }}>{t("Internal_Id")}</th>
                      <th style={{ width: "10%" }}>{t("part_name")}</th>
                      <th style={{ width: "10%" }}>{t("Model")}</th>
                      <th style={{ width: "10%" }}>{t("make")}</th>
                      <th style={{ width: "10%" }}>{t("quantity")}</th>
                      <th style={{ width: "10%" }}>{t("action")}</th>
                    </tr>
                  </thead>

                  <tbody>
                    {addedLers?.length > 0 ? (
                      addedLers?.map((item, index) => (
                        <tr key={index}>
                          <td>{item.parts_internal_id}</td>
                          <td>{item.namePartPT}</td>
                          <td>{item.vehicle_model_name}</td>
                          <td>{item.vehicle_make_name}</td>
                          <td>{item?.quantity}</td>
                          <td className="">
                            <button
                              className="btn-danger-delete"
                              href="#"
                              onClick={() =>
                                handleAddClickLER(
                                  item.id,
                                  item.parts_internal_id,
                                  item.namePartPT,
                                  item.vehicle_model_name,
                                  item.vehicle_make_name,
                                  item.quantity,
                                )
                              }
                            >
                              <i className="bi bi-trash3"></i>
                            </button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr className="scrollBrdr">
                        <td colSpan="100%">{t("no_record_found")}</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PartInventoryFilterList;
